import React from "react";
// import { HelpCircle } from "lucide-react";
// import PrimaryCard from "../../../components/cards/PrimaryCard";
import Button from "../../ui/Button";
// import PayoutItem from "./sections/PayoutItem";
import EarningsSummary from "./sections/EarningsSummary";
import EarningsChart from "./sections/EarningsChart";

const EarningsDashboard: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="flex items-center justify-between w-full mx-auto p-4 sm:p-6 lg:p-8">
        <h1 className="text-lg sm:text-xl font-semibold text-gray-500">
          Your Earnings
        </h1>
        <Button
          label="Request Withdrawal"
          customStyle={{ width: "auto", height: "30px" }}
        />
      </div>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2">
        {/* Available Balance Banner */}
        <div className="bg-[#3F2EC833] rounded-lg p-6 mb-6">
          <p className="text-sm text-purple-900 mb-2">Available balance</p>
          <p className="text-4xl font-bold ">₦0</p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 mb-6">
          {/* Left Column - Stats */}
          <EarningsSummary />
          <EarningsChart />
          {/* Right Column - Chart and History */}
        </div>{" "}
        {/* <PrimaryCard className="p-6">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-lg font-semibold text-gray-900">
              Payout History
            </h2>
            <button className="p-2 hover:bg-gray-100 rounded-lg transition-colors">
              <HelpCircle className="w-5 h-5 text-gray-500" />
            </button>
          </div> */}
        {/* <div className="space-y-0">
            <PayoutItem
              amount="N0.00"
              date="Thursday 12 May, 2025"
              status="Paid"
              reference="New success withdrawal"
            />
            <PayoutItem
              amount="N0.00"
              date="Friday 14 May, 2025"
              status="Paid"
              reference="New success withdrawal"
            />
            <PayoutItem
              amount="N0.00"
              date="Thursday 15 May, 2025"
              status="Failed"
              reference="New failed withdrawal"
            />
            <PayoutItem
              amount="N0.00"
              date="Friday 14 May, 2025"
              status="Paid"
              reference="New success withdrawal"
            />
            <PayoutItem
              amount="N0.00"
              date="Thursday 12 May, 2025"
              status="Failed"
              reference="New failed withdrawal"
            />
          </div> */}
        {/* </PrimaryCard> */}
      </main>
    </div>
  );
};

export default EarningsDashboard;
